module.exports = __webpack_public_path__ + "img/2024-09-19b_2.91d59b8d.jpg";